import 'css-chunksrc/client/pages/personalSpacePage/timeSheet/month/styles.scss';export default {
  "month": "_month_1uddh_1",
  "name": "_name_1uddh_11",
  "week": "_week_1uddh_18"
};